import React from "react";
import './OrderBanner.css';

const OrderBanner = () => {
    return (
        <div className="shop-banner">
            <span className="shop-banner-title">All cake orders:</span>
            <span>
                Pickup or we deliver in and around 25 miles of East Brunswick - 08816
            </span>
            <span className="blink">
                Delivery only on weekends.
            </span>
        </div>
    )
}

export default OrderBanner;
